import React, { lazy, Suspense } from 'react';

import clientOnly from '../../../hoc/clientOnly';

const YoutubeEmbed = lazy(() =>
  import(/* webpackChunkName: "YoutubeEmbed" */ './YoutubeEmbed')
);

const Loader = ({ classes, ...props }) => (
  <div className={classes}>
    <Suspense fallback={null}>
      <YoutubeEmbed {...props} />
    </Suspense>
  </div>
);

export default clientOnly(Loader);
